import { BUTTON_TYPES, DSButtonV2 } from '@elliemae/ds-button';
import { DSTooltipV3, tooltipPositions } from '@elliemae/ds-tooltip';
import { memo } from 'react';
import { StyledMIButtonWrapper } from './styled';
import { MILoadingSkeleton } from './MILoadingSkeleton';

export const MI_NOT_APPLICABLE_TOOLTIP =
  'MI is not applicable for this program';
export const MI_ALREADY_ORDERED_TOOLTIP = 'MI has already been ordered';

interface GetMIButtonProps {
  isDisabled: boolean;
  isLoading?: boolean;
  onClick: () => void;
  disabledTooltip?: string;
  isError?: boolean;
  errorTooltip?: string;
}

export const GetMIButton = memo(function GetMIButton({
  isDisabled,
  isLoading = false,
  onClick,
  disabledTooltip = MI_NOT_APPLICABLE_TOOLTIP,
  isError = false,
  errorTooltip,
}: GetMIButtonProps) {
  if (isLoading) {
    return (
      <StyledMIButtonWrapper
        onClick={(e) => e.stopPropagation()}
        data-testid="get-mi-button-loading"
      >
        <MILoadingSkeleton />
      </StyledMIButtonWrapper>
    );
  }

  const label = isError ? 'MI Error' : 'Get MI';

  const button = (
    <DSButtonV2
      buttonType={BUTTON_TYPES.OUTLINE}
      disabled={isDisabled}
      onClick={!isDisabled ? onClick : undefined}
      data-testid="get-mi-button"
      size="s"
    >
      {label}
    </DSButtonV2>
  );

  if (isError && errorTooltip) {
    return (
      <StyledMIButtonWrapper
        onClick={(e) => e.stopPropagation()}
        isError={isError}
      >
        <DSTooltipV3
          startPlacementPreference={tooltipPositions.TOP}
          text={errorTooltip}
          withoutPortal={false}
          wrapWords
        >
          {button}
        </DSTooltipV3>
      </StyledMIButtonWrapper>
    );
  }

  return (
    <StyledMIButtonWrapper onClick={(e) => e.stopPropagation()}>
      {isDisabled ? (
        <DSTooltipV3
          startPlacementPreference={tooltipPositions.TOP}
          text={disabledTooltip}
          withoutPortal={false}
        >
          {button}
        </DSTooltipV3>
      ) : (
        button
      )}
    </StyledMIButtonWrapper>
  );
});
